module.exports = __webpack_public_path__ + "img/unacloud.0a89f8d7.png";